module.exports = __webpack_public_path__ + "img/new2wm.bb5d5195.png";